import React from 'react';
import { ROADMAP_PHASES } from '../config/ztaArchitectureData';

const ZtaRoadmapLayer = () => {
  return (
    <section className="zta-layer zta-roadmap">
      <div className="zta-roadmap-label">ZERO TRUST MATURITY ROADMAP</div>
      <div className="zta-roadmap-phases">
        {ROADMAP_PHASES.map(phase => (
          <div
            key={phase.phase}
            className="zta-roadmap-phase"
            style={{ '--phase-color': phase.color }}
          >
            <div className="zta-phase-header">
              PHASE {phase.phase} | {phase.period}
            </div>
            <div className="zta-phase-items">{phase.items}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ZtaRoadmapLayer;
